import React from 'react';
import { AssetExportConfiguration } from '../types/asset_export_configuration';

export interface AssetExportConfigurationContextProps {
  assetExportConfigurations: Map<string, AssetExportConfiguration>;
  setAssetExportConfigurations: (assetExportConfigurations: Map<string, AssetExportConfiguration>) => void;
  assetExportConfigurationsLoading: boolean;
}

const defaultContext: AssetExportConfigurationContextProps = {
  assetExportConfigurations: new Map(),
  setAssetExportConfigurations: () => {},
  assetExportConfigurationsLoading: false,
};

export const AssetExportConfigurationContext =
  React.createContext<AssetExportConfigurationContextProps>(defaultContext);
